import React from "react";

import { css } from "glamor";

const styles = {
    wrapper: css({
        alignItems: "center",
        display: "flex",
        minHeight: "100vh",
        justifyContent: "center",
    }),
};

const CentreWrapper = props => {
    const { children } = props;
    return (
        <div {...styles.wrapper} {...props}>
            {children}
        </div>
    );
};

export default CentreWrapper;
